<template>
    <div>
        <m-assembly-table ref='pageForm'
                        needScrollBar
                        needSticky
                        columnDrag
                        thDrag
                        :formData='formData'
                        :columns='columnsFilter'
                        :data='tableData'
                        :tableButtons='tableButtons'
                        :loading='loading'
                        :currentPage='settings.currentPage'
                        :pageSize='settings.pageSize'
                        :total='settings.total'
                        :settings='settings'
                        :height="600"
                        @onSubmit='onSubmit'
                        @onPageSizeChange='onPageSizeChange'
                        @onCurrentPageChange='onPageChange'
                        @onSelectionChange="onSelectionChange"
        >
        <div style="border:1px solid #CCC;border-bottom:none;padding:10px;" slot="button">
            <span style="color:red;" v-if="locationRequired">*</span>{{$t('createDeliveryOrderByOrder.t9')}}：
            <Select class="mr10" style="width:200px;" size="small" v-model="location" :disabled="locationList.length === 0">
                <Option v-for="(item, key) in locationList" :value="item.value" :label="item.label" :key="key"></Option>
            </Select>
            <Button class="mr10" size="small" type="primary" @click="createOrderByPo" :disabled="selection.length === 0">{{$t('createDeliveryOrderByOrder.t32')}}</Button>
            <Button type="primary" class="mr10" @click="exportExcel" :loading="loading" size="small">{{$t('common.export')}}</Button>
            <set-table style="margin-right:10px;" :columns="columns.columns" buttonSize="small" @setTableUpdate="setTableUpdate"></set-table>
            <Checkbox v-model="isMergeItemCode" size="small" true-value="Y" false-value="N">{{$t('createDeliveryOrderToInformView.t62')}}</Checkbox>
            <span>{{ $t('createDeliveryOrderToInformView.t52') }}：{{ deliveryTotal }}</span>
        </div>
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import { exportExcel2 } from '@/modules/globalprotal/views/financialAccounting/financialAccounting.js'
import { deliveryTotalCount } from '@/utils/tool';
export default {
    name: 'createDeliveryOrderByOrder',
    components: { 
        mAssemblyTable 
    },
    computed: {
        columnsFilter() {
            /* 是否报关为“否”的时候，不显示‘报关已制单数量’、‘已报关数量’、‘贸易方式’、报关单号、‘进口通知书号’； */
            let columns = this.isCustomsDeclaration !== 'N' ? this.columns : {
                columns: this.columns.columns.filter((item) => !['alreadyCreateCustomsQty', 'dealQuantity', 'bondedTradeType', 'customsDeclarationNumber', 'imptNumber'].includes(item.key)) 
            };
            /* 判断是否外部供应商，是则增加“发票号” 字段 */
            columns = this.interiorVendor ? { columns: columns.columns.filter((item) => item.key !== 'invoiceNumber') } : columns;
            /* 判断是否展示“柜号” */
            columns = this.contSwitch ? columns : { columns: columns.columns.filter((item) => item.key !== 'cont') }
            return columns;
        },
        /* 是否内部供应商 */
        interiorVendor() {
            return this.vendorCode.startsWith('E');
        },
        /* 送货地点必填 */
        locationRequired() {
            /*
                1.内部供应商，报关为否，则INT_CUX_DELIVERY_LOCATIONS字典有配置则强控；
                2.外部供应商，INT_CUX_DELIVERY_LOCATIONS字典有配置则强控；
            */
            const noCustomsDeclaration = this.getFormDataItemVal(this.formData.items, 'isCustomsDeclaration') === 'N'; // 不需要报关
            const hasLocation = this.locationList.length > 0; // 字典有配置
            return this.interiorVendor ? (this.isCus && noCustomsDeclaration && hasLocation) : hasLocation;
        },
        /* 是否排除报关 */
        excludeBg() {
            const orgCode = this.getFormDataItemVal(this.formData.items, 'orgCode');
            return this.INT_CREATE_PO_CONTRAL.some((item) => item.value === orgCode && (item.attribute1 && !item.attribute1.includes(this.vendorCode)));
        },
        /* 柜号显示开关 */
        contSwitch() {
            return this.INT_CGZX_VENDOR_CODE.some((item) => item.value === this.vendorCode);
        },
    },
    data () {
        return {
            INT_CGZX_VENDOR_CODE: [],
            INT_CREATE_PO_CONTRAL: [],
            isCustomsDeclaration: 'Y',
            deliveryTotal: 0,
            isMergeItemCode: 'N',
            INT_ORGANIZATION_INCREASED: [],
            isCus: false,
            selection: [],
            location: '',
            locationName: '',
            locationList: [],
            formData: {
                row: 3,
                items: [
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        placeholder: this.$t('supplyRatioQueryTable.organizationHolder'),
                        value: '',
                        field: 'orgCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t49')
                            }
                        },
                        methods: {
                            change: (val) => {
                                // this.getShipToLoactionByCode(val);
                                if (val) {
                                    this.locationList = [];
                                    let data = [];
                                    data = this.locationListAll.filter(item => item.email === val);
                                    data.forEach((item) => {
                                        this.locationList.push({
                                            label: `${item.value} ${item.label}`,
                                            value: item.value
                                        })
                                    });
                                } else {
                                    this.locationList = [];
                                }
                                // 是否报关
                                this.isCusFun(val);
                                /* 是否按相同物料合并 */
                                this.isMergeItemCode = this.INT_ORGANIZATION_INCREASED.find((item) => item.code === val) ? 'Y' : 'N';
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'beginNeedByDate',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     }
                        // },
                        style: 'width:100%',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderToInformView.t2'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'endNeedByDate',
                        // validators: {
                        //     required: {
                        //         required: true,
                        //         message: this.$t('createDeliveryOrderToInformView.t49')
                        //     }
                        // },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'poNum',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderByOrder.t3')
                    },
                    {
                        value: '',
                        field: 'beginCreationDate',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        style: 'width:100%',
                        title: this.$t('createDeliveryOrderByOrder.t5'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'endCreationDate',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'noteToReceiver',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderByOrder.t6')
                    },
                    // {
                    //     value: '',
                    //     title: this.$t('createDeliveryOrderByOrder.t8'),
                    //     field: 'endItemCode',
                    //     disabled: false,
                    //     placeholder: '',
                    //     layout: {
                    //         span: 8,
                    //         offset: 0,
                    //         row: 2
                    //     },
                    //     options: {
                    //         rows: 1,
                    //         type: 'text'
                    //     },
                    //     type: 'text'
                    // },
                    {
                        value: '',
                        field: 'poType',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderByOrder.t4')
                    },
                    {
                        hide: false,
                        value: 'Y',
                        field: 'isCustomsDeclaration',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('importNoticeCommon.t117') + this.$t('createDeliveryOrderToInformView.t49')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            multiple: false,
                            clearable: false,
                            values: [
                                {
                                    label: this.$t('非空'),
                                    value: 'Y'
                                },
                                {
                                    label: this.$t('空'),
                                    value: 'N'
                                }
                            ],
                        },
                        type: 'select',
                        title: this.$t('importNoticeCommon.t117'),
                        methods: {
                            change: (val) => {
                                this.tableData = [];
                                this.selection = [];
                                this.isCustomsDeclaration = val;
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'itemCodeIn',
                        disabled: false,
                        placeholder: this.$t('createDeliveryOrderByOrder.t50'),
                        layout: {
                            span: 16,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderByOrder.t12')
                    },
                    { // 子库
                        value: '',
                        field: 'subInventory',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('deliveryNoticeConfirm.t10')
                    },
                ]
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 35
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t10'), // 子库
                        key: 'subInventory',
                        width: this.$i18n.locale === 'en-US' ? 100 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('invoiceMonitoring.t6'), // 柜号
                        key: 'cont',
                        minWidth: 110,
                        sortable: true,
                        tooltip: true,
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t11'), // 物料编码
                        key: 'itemCode',
                        minWidth: 110,
                        sortable: true
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t12'), // 物料描述
                        key: 'itemName',
                        minWidth: 200,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t23'), // 订单行
                        key: 'lineNum',
                        width: this.$i18n.locale === 'en-US' ? 60 : 50,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t22'), // 采购订单
                        key: 'poNumber',
                        minWidth: 100,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t14'), // 单位
                        key: 'primaryUom',
                        minWidth: 50,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t15'), // 未完成数量
                        key: 'unFinishedQuantiey',
                        align: 'right',
                        width: this.$i18n.locale === 'en-US' ? 100 : 90,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t16'), // 已制单数量
                        key: 'deliveryQuantity',
                        align: 'right',
                        width: this.$i18n.locale === 'en-US' ? 100 : 80,
                        sortable: true
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('Label', {
                                    style: {color: '#ff0000'}
                                }, '*'),
                                h('span', this.$t('createDeliveryOrderByOrder.t17'))
                            ]);
                        },
                        title: this.$t('createDeliveryOrderByOrder.t17'), // 本次送货数量
                        key: 'quantity',
                        width: this.$i18n.locale === 'en-US' ? 160 : 120,
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.quantity,
                                    size: 'small'
                                },
                                on: {
                                    'on-blur': (event) => {
                                        let val = event.target.value;
                                        let defaultVal = null;
                                        if (this.isBgCheck(params.row)) {
                                            // 是报关：本次送货数量=已报关数量-报关已制单数量
                                            defaultVal = this.numberSub(params.row.dealQuantity, params.row.alreadyCreateCustomsQty);
                                        } else {
                                            defaultVal = params.row.quantityCopy ? parseFloat(params.row.quantityCopy) : this.numberSub(params.row.unFinishedQuantiey, params.row.deliveryQuantity);
                                        }
                                        if (!this.validatePositive(val) || val === '0') {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('createDeliveryOrderByOrder.t43')
                                            });
                                            event.target.value = defaultVal;
                                            params.row.quantity = defaultVal;
                                        } else {
                                            if (Number(defaultVal) < Number(val)) {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('createDeliveryOrderByOrder.t44')
                                                });
                                                event.target.value = defaultVal;
                                                params.row.quantity = defaultVal;
                                            } else {
                                                params.row.quantity = event.target.value;
                                            }
                                            this.tableData[params.index] = params.row;
                                        }
                                        this.deliveryTotal = deliveryTotalCount(this.$refs.pageForm.getSelection(), 'quantity');
                                    }
                                }
                            });
                        },
                        sortable: true
                    },
                    {
                        title: this.$t('invoiceMonitoring.t1'), // 发票号,
                        key: 'invoiceNumber',
                        minWidth: 120,
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.invoiceNumber,
                                    size: 'small',
                                    maxlength: 100,
                                },
                                on: {
                                    'on-blur': (event) => {
                                        params.row.invoiceNumber = event.target.value;
                                        this.tableData[params.index] = params.row;
                                    }
                                }
                            })
                        },
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t46'), // 报关已制单数量
                        key: 'alreadyCreateCustomsQty',
                        minWidth: 100,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t47'), // 已报关数量
                        key: 'dealQuantity',
                        minWidth: 100,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t19'), // 贸易方式
                        key: 'bondedTradeType',
                        minWidth: 100,
                        sortable: true
                    },
                    {
                        renderHeader: (h, params) => {
                            let st1 = h('Label', {
                                style: {color: '#ff0000'}
                            }, '*');
                            let st2 = h('span', {}, this.$t('createDeliveryOrderByOrder.t18'));
                            let styleArr = [];
                            if (this.getFormDataItemVal(this.formData.items, 'isCustomsDeclaration') === 'Y') {
                                styleArr.push(st1);
                            }
                            styleArr.push(st2);
                            return h('span', styleArr);
                        },
                        title: this.$t('createDeliveryOrderByOrder.t18'), // 报关单号
                        key: 'customsDeclarationNumber',
                        width: this.$i18n.locale === 'en-US' ? 200 : 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t48'), // 进口通知书号
                        key: 'imptNumber',
                        minWidth: 120,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t41'), // 物料图号
                        key: 'itemChartNum',
                        minWidth: 120,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t20'), // 需求时间
                        key: 'needByDate',
                        minWidth: 125,
                        sortable: true
                    },
                    // {
                    //     title: this.$t('createDeliveryOrderByOrder.t21'), // 生产批次
                    //     key: 'productBatch',
                    //     minWidth: 120,
                    //     sortable: true
                    // },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t1'), // 库存组织
                        key: 'organizationCode',
                        minWidth: 100
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t25'), // 厂区
                        key: 'locationCode',
                        minWidth: 100
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t30'), // 仓管员
                        key: 'warehouseWorkers',
                        width: this.$i18n.locale === 'en-US' ? 140 : 100,
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t27'), // 接收类型
                        key: 'receivingMethod',
                        width: this.$i18n.locale === 'en-US' ? 120 : 100,
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t4'), // '订单类型',
                        key: 'poTypeName',
                        tooltip: true,
                        minWidth: 100
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t6'), // '说明',
                        key: 'comments',
                        minWidth: 150
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t30'), // '采购说明',
                        key: 'purchaseApplyExplain',
                        minWidth: 150
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t31'), // '作业号',
                        key: 'productionTask',
                        minWidth: 110
                    }
                    // {
                    //     title: '头-保税类型',
                    //     key: '',
                    //     minWidth: 100
                    // },
                    // {
                    //     title: '行-保税类型',
                    //     key: '',
                    //     minWidth: 100
                    // }
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: []
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 100,
                total: null,
                submitLoading: false
            },
            INT_BONDED_TYPE: [],
            INT_CUX_DELIVERY_ASSOCIATED_DEC: [],
            INT_CUX_DELIVERY_LOCATIONS: [],
            INT_GSCPOTYPE: []
        }
    },
    methods: {
        onSubmit (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSelectionChange (selection) {
            this.selection = selection;
            this.deliveryTotal = deliveryTotalCount(this.$refs.pageForm.getSelection(), 'quantity');
        },
        onSearch () {
            this.loading = true;
            let postData = this.getFormDataVModel(this.formData.items);
            axios.post('/gscint/order/queryCanCreateOrderPo', {
                ...postData,
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.$i18n.locale,
                isCustomsDeclaration: this.isCus ? postData.isCustomsDeclaration : ''
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data.code === '1') {
                    data.datas.list.map((item) => {
                        if (this.isBgCheck(item)) {
                            // 是报关：本次送货数量=已报关数量-报关已制单数量
                            item.quantity = this.numberSub(item.dealQuantity, item.alreadyCreateCustomsQty);
                        } else {
                            if (item.quantity) {
                                item.quantityCopy = item.quantity;
                            }
                        }
                        return item;
                    });
                    this.tableData = data.datas.list;
                    this.settings.total = data.datas.total;
                    this.selection = [];
                    this.deliveryTotal = deliveryTotalCount([], 'quantity');
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 送货地点
        // getShipToLoactionByCode (invCode) {
        //     axios.post('/gscint/order/getShipToLoactionByCode', {
        //         invCode,
        //         language: this.$i18n.locale
        //     })
        //     .then((res) => {
        //         this.locationList = [];
        //         let data = res.data.data.datas;
        //         let list = [];
        //         if (data) {
        //             data.forEach((item) => {
        //                 list.push({
        //                     label: `${item.LOOKUPCODE} ${item.SHIPLOCATIONDESC}`,
        //                     value: item.LOOKUPCODE
        //                 })
        //             });
        //             this.locationListAll = data;
        //             this.locationList = list;
        //         }
        //     });
        // },
        // 精度问题处理
        numberSub (num1, num2) {
            let baseNum;
            let baseNum1;
            let baseNum2;
            let precision;// 精度
            try {
                baseNum1 = num1.toString().split(".")[1].length;
            } catch (e) {
                baseNum1 = 0;
            }
            try {
                baseNum2 = num2.toString().split(".")[1].length;
            } catch (e) {
                baseNum2 = 0;
            }
            baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
            precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
            return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
        },
        // 最多保留2位小数
        validatePositive: function (needTest) {
            var rel = /^[0-9]+\.?[0-9]{0,4}$/;
            return rel.test(needTest);
        },
        // 创建送货单
        createOrderByPo () {
            let isCustomsDeclaration = this.getFormDataItemVal(this.formData.items, 'isCustomsDeclaration') === 'Y';
            if (!this.location && this.locationRequired) {
                this.$Modal.error({
                    content: this.$t('createDeliveryOrderByOrder.t33')
                });
                return false;
            }
            let poDelDtoList = this.$refs.pageForm.$refs.iTable.$refs.iTable.getSelection();
            let tag = false, msg = '';
            poDelDtoList.forEach((item) => {
                if (this.isBgCheck(item) && item.customsCanCreate === 'N') { // 是报关且customsCanCreate === 'N'
                    msg = this.$t('createDeliveryOrderByOrder.t49');
                    tag = true;
                }
            });
            if (tag) {
                this.showErrorTips(null, msg);
                return false;
            }
            const createFun = () => {
                this.loading = true;
                try {
                    axios.post('/gscint/order/createOrderByPo', {
                        timestamp: new Date().getTime(),
                        vendorCode: this.vendorCode,
                        vendorId: this.vendorId,
                        orgCode: poDelDtoList[0].organizationCode,
                        // orgId: this.orgList.find((item) => item.organizationCode === orgCode).organizationId,
                        delpalace: this.location,
                        delpalaceName: (this.location && this.locationListAll.find((item) => item.value === this.location).label) || '',
                        poDelDtoList,
                        isCustomsDeclaration: isCustomsDeclaration ? 'Y' : 'N',
                        isMergeItemCode: this.isMergeItemCode === 'Y'
                    })
                    .then((res) => {
                        this.loading = false;
                        let data = res.data.data;
                        if (data.code === '1') {
                            this.$Modal.success({
                                content: data.msg
                            });
                            this.selection = [];
                            this.deliveryTotal = deliveryTotalCount([], 'quantity');
                            this.onSearch();
                        } else {
                            this.$Modal.error({
                                content: data.msg
                            });
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
                } catch (err) {
                    console.log(err);
                }
            }
            /* 判断是否需要展示柜号提示 */
            if (this.contSwitch) {
                const conts = poDelDtoList.filter((item) => item.cont).map((item) => item.cont);
                if (conts.length > 0) {
                    this.$Modal.confirm({
                        content: `${this.$t('createDeliveryOrderByOrder.t53')}${conts.join()}${this.$t('createDeliveryOrderByOrder.t54')}`,
                        onOk: () => {
                            createFun();
                        },
                    });
                } else {
                    createFun();
                }
            } else {
                createFun();
            }
        },
        // 导出excel
        exportExcel() {
            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                this.loading = true;
                const postData = this.getFormDataVModel(this.formData.items);
                exportExcel2('/gscint/order/exportCanCreateOrderPo', {
                    ...postData,
                    vendorCode: this.vendorCode,
                    pageIndex: this.settings.currentPage,
                    pageSize: this.settings.pageSize,
                    language: this.$i18n.locale,
                    isCustomsDeclaration: this.isCus ? postData.isCustomsDeclaration : '',
                }, `${this.$t('createDeliveryOrderByOrder.t40')}.xls`, this)
                    .finally(() => {
                        this.loading = false;
                    });
            }
            // const options = {
            //     anchor: 'anchor',
            //     filename: this.$t('createDeliveryOrderByOrder.t40'),
            //     format: 'xlsx'
            // };
            // let columns = [];
            // this.columns.columns.map((item) => {
            //     if (item.title) {
            //         columns.push(item.title);
            //     }
            // });
            // let datas = [];
            // this.$refs.pageForm.$refs.iTable.data.map((item, key) => {
            //     datas.push([]);
            //     this.columns.columns.map((item2) => {
            //         if (item2.title) {
            //             datas[key].push(item[item2.key] ? item[item2.key] : '');
            //         }
            //     })
            // });
            // console.log('datas', datas);

            // const sheets = [
            //     {
            //         name: this.$t('createDeliveryOrderByOrder.t40'),
            //         from: {
            //             array: [
            //                 columns,
            //                 ...datas
            //             ]
            //         }
            //     }
            // ];
            // ExcellentExport.convert(options, sheets);
        },
        isCusFun (val) {
            this.isCus = false;
            this.columns.columns = this.columns.columns.filter((item) => !['alreadyCreateCustomsQty', 'dealQuantity', 'customsDeclarationNumber', 'imptNumber'].includes(item.key));
            if (this.INT_CUX_DELIVERY_ASSOCIATED_DEC.find((item) => item.code === val)) {
                this.isCus = true;
                this.columns.columns = this.columnsCopy;
            }
            this.$set(this.getFormDataItemObj(this.formData.items, 'isCustomsDeclaration'), 'hide', !this.isCus);
            try {
                this.$set(this.getFormDataItemObj(this.formData.items, 'subInventory'), 'layout', {
                    span: 8,
                    offset: 0,
                    row: this.isCus ? 3 : 2,
                });
                this.$set(this.getFormDataItemObj(this.formData.items, 'supplierInvoiceNumber'), 'layout', {
                    span: 8,
                    offset: 0,
                    row: this.isCus ? 3 : 2,
                });
            } catch (err) {
                console.log(err);
            }
        },
        /** 深拷贝 */
        objDeepCopy: function (source) {
            var sourceCopy = source instanceof Array ? [] : {};
            for (var item in source) {
                if (typeof source[item] === 'object') {
                    if (source[item] === null) {
                        sourceCopy[item] = null;
                    } else {
                        sourceCopy[item] = this.objDeepCopy(source[item]);
                    }
                } else {
                    sourceCopy[item] = source[item];
                }
            }
            return sourceCopy;
        },
        setTableUpdate(columns) {
            this.columns.columns = columns;
        },
        /* 是否报关判断 */
        isBgCheck(item) {
            const bondedTradeTypeArr = this.INT_BONDED_TYPE.map(dict => dict.value);
            console.log('是否报关', bondedTradeTypeArr.includes(item.bondedTradeType), this.isCus, !this.excludeBg);
            return bondedTradeTypeArr.includes(item.bondedTradeType) && this.isCus && !this.excludeBg;
        },
    },
    mounted () {
        this.columnsCopy = this.objDeepCopy(this.columns.columns);
        this.getDict('INT_GSCPOTYPE', (data) => {
            this.getFormDataItemObj(this.formData.items, 'poType').options.values = data;
        });
        this.getSRMInvLovListNew((data) => {
            let list = [];
            this.orgList = data;
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.organizationCode
                });
            });
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = list;
        });
        // 判断是否报关标识
        this.getDict('INT_BONDED_TYPE');
        // 送货地点
        this.getDict('INT_CUX_DELIVERY_LOCATIONS', (data) => {
            this.locationListAll = data;
        });
        // 是否显示报关的信息
        this.getDict('INT_CUX_DELIVERY_ASSOCIATED_DEC');
        /* 判断合并是否区分物料编码 */
        this.getDict('INT_ORGANIZATION_INCREASED');
        /* 非E编码是否报关默认为否 */
        if (this.vendorCode.indexOf('E') !== 0) {
            this.getFormDataItemObj(this.formData.items, 'isCustomsDeclaration').value = 'N';
        }
        /* 是否需要判断贸易属性 */
        this.getDict('INT_CREATE_PO_CONTRAL');
        /* 是否显示柜号 */
        this.getDict('INT_CGZX_VENDOR_CODE');
    }
}
</script>
<style lang="less" scoped>
.mr10 {
    margin-right: 10px;
}
</style>